export default function separateThumbs(arr) {
  const media = [];
  const thumbs = {};

  arr.forEach((item) => {
    const baseName = item.split('.')[0];
    if (baseName.endsWith('_thumb')) {
      // Extract the corresponding media file name and use it as a key in thumbs object
      const mediaName = item.substring(0, item.lastIndexOf('_thumb'));
      thumbs[mediaName] = item;
    } else {
      media.push(item);
    }
  });

  return { media, thumbs };
}